import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()(() => {
    return {
        container: {
            height: '100%',
            width: '100%',
            display: 'flex',
        },
    }
})

export default useStyles
